import axios from 'axios';

import { publicAxiosHeader, getV1RootUrl } from 'common/helpers/apiHelper';

export const getClubSignup = (clubSignupId) =>
  axios.get(
    `${getV1RootUrl()}/club-signup/${clubSignupId}`,
    publicAxiosHeader()
  );

export const createClubSignup = (clubSignup) =>
  axios.post(`${getV1RootUrl()}/club-signup`, clubSignup, publicAxiosHeader());

export const updateClubSignup = (clubSignupId, clubSignup) =>
  axios.put(
    `${getV1RootUrl()}/club-signup/${clubSignupId}`,
    clubSignup,
    publicAxiosHeader()
  );

export const processClubSignup = (clubSignupId) =>
  axios.put(
    `${getV1RootUrl()}/club-signup/${clubSignupId}/process`,
    null,
    publicAxiosHeader()
  );

export const sendClubSignupToHostedPayment = (clubSignupId) =>
  axios.post(
    `${getV1RootUrl()}/club-signup/${clubSignupId}/hosted-payment`,
    null,
    publicAxiosHeader()
  );
